import styled from 'styled-components';
import * as grid from 'view/styles/grid';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line rulesdir/no-styled-export
export const EmbedComponentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    border: ${grid.multiple(1 / 8).px} solid ${token('color.border.bold', colors.N30)};
    border-radius: ${grid.multiple(3 / 8).px};
    box-sizing: border-box;
`;
